<ng-container [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <a
      class="hover-tile focus-link container rounded-md"
      [routerLink]="url"
      [queryParamsHandling]="'preserve'"
      [attr.aria-label]="
        'accessibility.offer.list_item_aria_label'
          | translate: { title: this.title, brand: this.brand }
      ">
      <div class="cover" [ngClass]="imageRatioClass()">
        <img
          class="h-full w-full object-cover object-center"
          [src]="coverImage" />
        <div class="category-icon-container" *ngIf="renderCategoryIcon">
          <rd-shared-icon
            class="offer-category-icon"
            [iconSymbol]="categoryIcon"
            [iconTheme]="'primary'"></rd-shared-icon>
        </div>
      </div>
      <div class="content">
        <div class="offer-text">
          <h2 class="offer-brand">{{ brand }}</h2>
          <h3 class="offer-title">{{ title }}</h3>
        </div>
        <div class="logo-wrapper" *ngIf="logo">
          <img class="logo" [src]="logo" [alt]="brand + ' logo'" />
        </div>
      </div>
    </a>
  </ng-container>

  <ng-container *ngSwitchCase="'loading'">
    <div class="container rounded-md">
      <div class="cover cover-loading" [ngClass]="imageRatioClass()">
        <div class="category-icon-container" *ngIf="renderCategoryIcon"></div>
      </div>
      <div class="loading">
        <div class="offer-text">
          <div class="loading-offer-brand"></div>
          <div class="loading-offer-title"></div>
        </div>
        <div class="loading-img" [ngClass]="imageRatioClass()"></div>
      </div>
    </div>
  </ng-container>
</ng-container>
